import { toPng } from "html-to-image";

export const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
export function getFinancialYearStart() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0 = Jan, 1 = Feb, 2 = Mar ...

  // If before April (Jan, Feb, Mar), financial year starts last year
  const fyStartYear = month < 3 ? year - 1 : year;

  return new Date(fyStartYear, 3, 1); // April 1st
}
export function getFYStartDateFormatted(currentDate = new Date()) {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1; // 1–12

  // If month < April, FY started on Apr 1 of previous year
  const fyYear = month < 4 ? year - 1 : year;

  // Format as YYYY/MM/DD
  return (
    fyYear +
    "-" +
    String(4).padStart(2, "0") + // April = 04
    "-" +
    String(1).padStart(2, "0") // Day = 01
  );
}

export const getCurrentMonthFirstDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-01`;
};
export const getLastDateOfFY = (getDate) => {
  let date = getDate ? new Date(getDate) : new Date(); // convert string to Date object if needed

  const year = date.getFullYear();
  const month = date.getMonth() + 1; // JavaScript months are 0-based

  // If the month is Jan (1), Feb (2), or Mar (3), current FY ends in that year's March
  // Otherwise, the FY ends in March of next year
  const fyEndYear = month < 4 ? year : year + 1;

  return `${fyEndYear}-03-31`;
};

export const getOnePreviousDate = () => {
  const date = new Date();
  date.setDate(date.getDate() - 1); // Subtract 1 day

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const formatToDate = (value) => {
  // Handle multiple date formats
  const dateRegex = /^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})$/;
  const match = value.match(dateRegex);

  if (match) {
    let day, month, year;

    if (value.includes("-")) {
      // Handle MM-DD-YYYY or DD-MM-YYYY
      const parts = value.split("-");
      if (parts[0].length === 4) {
        // YYYY-MM-DD
        return value;
      } else {
        // MM-DD-YYYY or DD-MM-YYYY
        month = parts[0].padStart(2, "0");
        day = parts[1].padStart(2, "0");
        year = parts[2].length === 2 ? `20${parts[2]}` : parts[2];
      }
    } else if (value.includes("/")) {
      // Handle DD/MM/YYYY or MM/DD/YYYY
      const parts = value.split("/");
      day = parts[0].padStart(2, "0");
      month = parts[1].padStart(2, "0");
      year = parts[2].length === 2 ? `20${parts[2]}` : parts[2];
    } else {
      return value; // Return as-is if it doesn't match
    }

    return `${year}-${month}-${day}`;
  }

  return value;
};

export function getDaysInMonth(fyYear, month) {
  // Fiscal Year: "2024_25" => Extract start & end years
  let [startYear, endYear] = fyYear.split("_").map(Number);
  // Month mapping (short name to month index)
  const monthMap = {
    APR: 3,
    MAY: 4,
    JUN: 5,
    JUL: 6,
    AUG: 7,
    SEP: 8,
    OCT: 9,
    NOV: 10,
    DEC: 11,
    JAN: 0,
    FEB: 1,
    MAR: 2,
  };

  // Find the actual year based on fiscal rules
  let year = monthMap[month] >= 3 ? startYear : endYear;

  // Get days in month
  return new Date(year, monthMap[month] + 1, 0).getDate();
}

export function getDayDiffBetweenFiscalMonths(fyYear, startMonth, endMonth) {
  const monthMap = {
    APR: 3,
    MAY: 4,
    JUN: 5,
    JUL: 6,
    AUG: 7,
    SEP: 8,
    OCT: 9,
    NOV: 10,
    DEC: 11,
    JAN: 0,
    FEB: 1,
    MAR: 2,
  };

  let [startYearRaw, endYearRaw] = fyYear.replace("-", "_").split("_");

  const startYear = Number(startYearRaw); // e.g. 2016
  const endYear =
    endYearRaw?.length === 2
      ? Number(startYearRaw.slice(0, 2) + endYearRaw) // e.g. "20" + "17" = 2017
      : Number(endYearRaw);

  const getActualYear = (month) => (monthMap[month] >= 3 ? startYear : endYear);

  const startDate = new Date(
    getActualYear(startMonth?.toUpperCase()),
    monthMap[startMonth?.toUpperCase()],
    1,
  );

  const endDate = new Date(
    getActualYear(endMonth?.toUpperCase()),
    monthMap[endMonth?.toUpperCase()] + 1,
    0,
  );

  const diffInMs = endDate - startDate;
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24)) + 1;

  return diffInDays;
}
// ////////////////////////////////////////////////////////////////////////
export const months = [
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
  "JAN",
  "FEB",
  "MAR",
];
// ////////////////////////// get days by 2 month  and Fy//////////////////////////
export function getDaysBetweenMonths(fy, startMonth, endMonth) {
  const monthOrder = [
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
    "JAN",
    "FEB",
    "MAR",
  ];

  // If endMonth is not provided, use startMonth
  if (!endMonth) endMonth = startMonth;

  const [startFYYear, endFYYear] = fy.split("_").map(Number);

  const startIndex = monthOrder?.indexOf(startMonth?.toUpperCase());
  const endIndex = monthOrder?.indexOf(endMonth?.toUpperCase());

  if (startIndex === -1 || endIndex === -1) {
    return "Invalid month name";
  }

  // If endMonth is before startMonth, return 0 or error
  if (endIndex < startIndex) {
    return "End month cannot be before start month";
  }

  let totalDays = 0;

  for (let i = startIndex; i <= endIndex; i++) {
    const month = monthOrder[i];

    let year = startFYYear;

    // Jan–Mar belong to next FY
    if (["JAN", "FEB", "MAR"].includes(month)) {
      year = endFYYear;
    }

    // Get number of days in the month
    const date = new Date(`${month} 1, ${year}`);
    const days = new Date(year, date.getMonth() + 1, 0).getDate();

    totalDays += days;
  }

  return totalDays;
}
// ///////////////////////////////////////////////////////////////////////////////////////////////
export function getDaysInFYMonths(fyInput, monthsArray) {
  if (!fyInput || !monthsArray || !Array.isArray(monthsArray)) {
    throw new Error("Invalid input: FY year and months array are required");
  }

  // ---- Extract the starting year from various FY formats ----
  const fyStr = String(fyInput).trim();
  let startYear;

  // Match patterns like 2025_26, 2025-26, 2025/26, 202526, or just 2025
  const match = fyStr.match(/^(\d{4})[_\/-]?\d{0,2}$/);
  if (match) {
    startYear = parseInt(match[1], 10);
  } else {
    throw new Error(
      "Invalid FY format. Use formats like: 2025, 2025_26, 2025-26, 2025/26",
    );
  }

  if (startYear < 1900 || startYear > 2100) {
    throw new Error("FY year out of valid range");
  }

  // ---- Month mapping (case-insensitive + short forms + numbers) ----
  const monthMap = {
    january: 1,
    jan: 1,
    1: 1,
    february: 2,
    feb: 2,
    f: 2,
    2: 2,
    march: 3,
    mar: 3,
    mr: 3,
    3: 3,
    april: 4,
    apr: 4,
    ap: 4,
    4: 4,
    may: 5,
    my: 5,
    5: 5,
    june: 6,
    jun: 6,
    jn: 6,
    6: 6,
    july: 7,
    jul: 7,
    jy: 7,
    7: 7,
    august: 8,
    aug: 8,
    au: 8,
    8: 8,
    september: 9,
    sep: 9,
    sept: 9,
    se: 9,
    9: 9,
    october: 10,
    oct: 10,
    oc: 10,
    10: 10,
    november: 11,
    nov: 11,
    no: 11,
    11: 11,
    december: 12,
    dec: 12,
    de: 12,
    12: 12,
  };

  // Normalize months
  const validMonthNumbers = monthsArray
    .map((m) => String(m).trim().toLowerCase())
    .filter((m) => m)
    .map((m) => monthMap[m])
    .filter((num) => num !== undefined);

  if (validMonthNumbers.length === 0) {
    throw new Error("No valid months provided");
  }

  // ---- Leap year helper ----
  const isLeapYear = (y) => y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0);

  // ---- Days in a given month/year ----
  const daysInMonth = (month, year) => {
    const days = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month === 2 && isLeapYear(year)) return 29;
    return days[month];
  };

  // ---- Calculate total days ----
  let totalDays = 0;

  for (const month of validMonthNumbers) {
    const yearForMonth = month >= 4 ? startYear : startYear + 1; // Apr–Dec → startYear, Jan–Mar → next year
    totalDays += daysInMonth(month, yearForMonth);
  }

  return totalDays;
}
// //////////////////////////////////////////////////////////////////////////////////////////////////////
export const daysInGivenMonth = (month, year) => {
  const isLeapYear = (y) => y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0);
  const days = [30, 31, 30, 31, 31, 30, 31, 30, 31, 31, 28, 31]; //Fy wise order apr -march
  if (month === 2 && isLeapYear(year)) return 29;
  return days[month];
};
// ////////////////////////////////// MONTH NAME BASED ON NO //////////////////////////////////////////
export function getMonthAbbreviation(monthNumber, caps) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const capMonths = [
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
    "JAN",
    "FEB",
    "MAR",
  ];

  // Ensure the input is a number and valid (1-12)
  const index = parseInt(monthNumber, 10) - 1;
  if (caps) {
    return capMonths[index] || "Invalid";
  } else {
    return months[index] || "Invalid";
  }
}

// ///////////////////////////////////// DOWNLOAD REPORT AS IMAGE //////////////////////////////////////////
export const downloadImage = (reportRef, title) => {
  if (reportRef.current === null) return;

  toPng(reportRef.current, { cacheBust: true })
    .then((dataUrl) => {
      const link = document.createElement("a");
      link.download = `${title}}.png`;
      link.href = dataUrl;
      link.click();
    })
    .catch((err) => {
      return ("Could not generate image", err);
    });
};
// //////////////////////formate date to dd/mm/yyyy //// ///////////
export const formatDateToDis = (inputDate) => {
  const date = new Date(inputDate);

  if (isNaN(date)) return "-"; // Handle invalid date

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};
// //////////////////////////////color code/////////////////////////
export const colorMap = {
  "Previous Year": "#5470c6",
  "Current Year": "#91cc75",
  "Current Year Remaining": "#fa6e58ff",
  "Current Year Target": "#fac858",
  // ////////////////////////////
  QUATRE_1: "#3498db",
  QUATRE_2: "#2ecc71",
  QUATRE_3: "#f39c12",
  QUATRE_4: "#e74c3c",
  // //////////////////////
  PATH: "#a569bd",
  REPER_P: "#a569bd",
  REPER_N: "#f39c12",
  // /////////////////////
  DELC: "#a3e4d7",
  DSRC: "#f39c12",
  DSDF: "#e74c3c",
  //////////////////////////////
  INC: "#f25d9d",
  MED: "#6699ff",

  /////////////////////////
  ACP: "#ffcc00",
  DACP: "#a3e4d7",
  IACP: "#f85d5d",
  // ///////////////////////////////
  TFC: "#66ccff",
  K: "#ff6600",
  D: "#33cc33",
  E: "#9966ff",
  FC: "#ff3399",
  // ///////////////////////
  RUNO: "#ff6600",
  CRO: "#9966ff",
  HRO: "#ff3399",
  //////////////////////
  WEA: "#33cc33",
  FOG: "#9966ff",
  PAR: "#9966ff",
  CY: "#ff3399",
  //////////////////////
  ICW: "#9966ff",
  DELc: "#ff3399",
  // //////////////////////
  ST: "#33cccc",
  IBSF: "#ff5050",
  PTF: "#99cc00",
  GF: "#cc00ff",
  BIF: "#ff9933",
  TCF: "#3399ff",
  ADF: "#ff66cc",
  BACF: "#33ff99",
  HSF: "#ff3300",
  BB: "#6699ff",

  // //////////////////////////
  IELC: "#ff5050",
  IDSR: "#8fbc8f",
  SNWWEA: "#20b2aa",
  IDSF: "#ff7f50",
  /////////////////
  PBOL: "#99cc00",
  PBEOL: "#ff7f50",
  ////////////////////
  ACC: "#cc00ff",
  LINENC: "#ff9933",

  //////////////////////
  COM: "#3399ff",
  ULD: "#ff9933",

  // //////////////////////
  PT: "#ff66cc",
  OTH: "#33ff99",
  HP: "#ff3300",
  LC: "#6699ff",
  // //////////////////////
  ENG: "#33ff99",
  GIF: "#ff3300",
  CD: "#6699ff",
  GM: "#ffcc99",
  // //////////////
  CNST: "#ff3300",
  ////////////////////////
  LC: "#6699ff",
  "V DASH": "#33ff99",
  RD: "#ff3300",
  BR: "#6699ff",
  VD: "#ffcc99",
  //////////////////
  OHE: "#ffcc99",
  ///////////////////
  CONNI: "#b0e0e6",
  PST: "#ff3300",
  PENG: "#6699ff",
  UPENG: "#dda0dd",
  UPOHE: "#ffcc99",
  /////////////////////
  PRONI: "#dda0dd",
  /////////////////////////////
  ELEC: "#90ee90",
  UDMU: "#6699ff",
  DAC: "#dda0dd",
  "ENG.EL": "#ffcc99",
  ////////////////////
  MA: "#ffb6c1",
  ODAC: "#8fbc8f",
  PTFT: "#20b2aa",
  OTFT: "#ff7f50",
  ///////////////////
  IDSL: "#8fbc8f",
  UDDMU: "#20b2aa",

  /////////////////////
  LO: "#20b2aa",
  LOP: "#ff7f50",

  //////////////////
  DCW: "#ff1f90",
  AGT: "#ff7f50",
  RE: "#cd5c5c",
  PBC: "#5f9ea0",
  DDSL: "#d2b48c",
  0: "#d8bfd8",
  CEMENT: "#3498db",
  CLINKER: "#2ecc71",
  RMSP: "#f39c12",
  IRON_ORE: "#ff3300",
  COAL: "#ffcc00",
  CONTAINER_ALUM: "#dda0dd",
  FOOD_GRAIN: "#cc00ff",
  FERTILIZER: "#d2b48c",
  OTHERS: "#3498db",
};

// ////////////////////////////////////////////////////////////////////////////////////////////////////////
// COLOR CODE FOR CHARTS
// ////////////////////////////////////////////////////////////////////////////////////////////////////////
export function colorGenerator(baseKey, level) {
  const baseColors = {
    UNUSUAL: "#3498db",
    MECHANICAL: "#9D65D1",
    ELECTRICAL: "#e60073",
    "LAW AND ORDER": "#e74c3c",
    "SIGN AND TELE": " #Ff9900",
    ENGINEERING: "#33cc33",
    ORES: "#7F79DB",
    RMSP: "#ffcc00",
    COAL: "#66ccff",
  };

  const shadeAdjust = ["", "B3", "99", "66", "33"]; // alpha transparency for demo
  const base = baseColors[baseKey] || "#888888";
  return base + (shadeAdjust[level] || "");
}
// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
// GET  MONTHS PASSED AS FY
// /////////////////////////////////////////////////////////////////////////////////////////////////////////////
export const getFinancialYearMonthsPassed = (fyYear, fullForm = true) => {
  const months = [
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
    "January",
    "February",
    "March",
  ];

  const shortFormMap = {
    April: "Apr",
    May: "May",
    June: "Jun",
    July: "Jul",
    August: "Aug",
    September: "Sep",
    October: "Oct",
    November: "Nov",
    December: "Dec",
    January: "Jan",
    February: "Feb",
    March: "Mar",
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); // 0–11

  const fyStartYear =
    typeof fyYear === "string" ? parseInt(fyYear.split("-")[0]) : fyYear;
  const fyEndYear = fyStartYear + 1;

  // FY not started yet
  if (
    currentYear < fyStartYear ||
    (currentYear === fyStartYear && currentMonth < 3)
  ) {
    return new Set(["April"]);
  }

  // FY already completed
  if (
    currentYear > fyEndYear ||
    (currentYear === fyEndYear && currentMonth > 2)
  ) {
    return new Set(fullForm ? months : months.map((m) => shortFormMap[m]));
  }

  // FY currently running
  const fyMonthIndex =
    currentYear === fyStartYear ? currentMonth - 3 : currentMonth + 9;

  let passedMonths = months.slice(0, fyMonthIndex);

  // ✅ FIX: if FY started but no month passed yet → return April
  if (passedMonths.length === 0) {
    passedMonths = ["April"];
  }

  return new Set(
    fullForm ? passedMonths : passedMonths.map((m) => shortFormMap[m]),
  );
};

// /////////////////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////    MiNUTES TO HH:MM    ///////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////////////////////////////////////
export const minutesToHHMM = (minutes, secTrue) => {
  if (isNaN(minutes) || minutes < 0) {
    return "Invalid input";
  }

  const hours = Math.floor(minutes / 60);
  const mins = Math.floor(minutes % 60);
  const sec = Math.round((minutes * 60) % 60); // use seconds if needed

  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(mins).padStart(2, "0");
  const formattedSec = String(sec).padStart(2, "0");

  if (secTrue) {
    return `${formattedHours}:${formattedMinutes}:${formattedSec}`;
  } else {
    return `${formattedHours}:${formattedMinutes}`;
  }
};

export const secondsToTime = (totalSeconds) => {
  if (
    typeof totalSeconds !== "number" ||
    isNaN(totalSeconds) ||
    totalSeconds < 0
  )
    return "00:00:00";

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const pad = (num) => String(num).padStart(2, "0");

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};

// /////////////////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////    HH:MM TO MiNUTES    ///////////////////////////////////////////
// /////////////////////////////////////////////////////////////////////////////////////////////////////
// Convert hh:mm:ss to minutes
export const timeToMinutes = (timeStr) => {
  if (!timeStr || typeof timeStr !== "string") return 0;
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) return 0;
  return hours * 60 + minutes + seconds / 60;
}; // Convert hh:mm:ss to minutes

// ///////////////// HH:MM or HH:MM:SS to seconds/////////////////////////
export function timeToSeconds(timeStr) {
  let time = timeStr ? timeStr : "00:00:00";
  const parts = time?.split(":").map(Number);

  if (parts.length === 2) {
    // Format: HH:MM
    const [hours, minutes] = parts;
    return hours * 3600 + minutes * 60;
  } else if (parts.length === 3) {
    // Format: HH:MM:SS
    const [hours, minutes, seconds] = parts;
    return hours * 3600 + minutes * 60 + seconds;
  }
  // else {
  // throw new Error("Invalid time format. Use HH:MM or HH:MM:SS");
  // }
}

// /////////////////////////////////////////////////////////////////
////////////////////// // only collection of  mutated Object of array ///////////////////////////////
export function getModifiedObjects(originalArray, updatedArray) {
  const changed = [];

  const normalizeValue = (val) => {
    if (val == null || val === "") return "";

    // If numeric or numeric string → normalize to Number
    if (!isNaN(val) && val !== "") {
      return Number(val);
    }

    // If time string "HH:MM" or "HH:MM:SS" → normalize to HH:MM:SS
    if (typeof val === "string") {
      const match = val.match(/^(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/);
      if (match) {
        let [, hh, mm, ss] = match;
        hh = hh.padStart(2, "0");
        mm = mm.padStart(2, "0");
        ss = (ss || "00").padStart(2, "0");
        return `${hh}:${mm}:${ss}`;
      }
    }

    return val;
  };

  const originalMap = new Map(originalArray.map((obj) => [obj.Sno, obj]));

  updatedArray.forEach((updatedObj) => {
    const originalObj = originalMap.get(updatedObj.Sno);
    if (!originalObj) return;

    const changedKeys = Object.keys(updatedObj).filter((key) => {
      if (key === "Sno") return false;
      const orig = normalizeValue(originalObj[key]);
      const upd = normalizeValue(updatedObj[key]);
      return orig !== upd;
    });

    if (changedKeys.length > 0) {
      const modObj = { Sno: updatedObj.Sno };
      changedKeys.forEach((key) => {
        modObj[key] = updatedObj[key];
      });
      changed.push(modObj);
    }
  });

  return changed;
}

// ///////////////////////////////////////// timeToSeconds2 ////////////////////////////////////////////////////////////
export const timeToSeconds2 = (timeString) => {
  if (!timeString || typeof timeString !== "string") return 0;

  const parts = timeString.split(":").map(Number);

  if (parts.length === 2) {
    // HH:MM
    const [hours, minutes] = parts;
    return hours * 3600 + minutes * 60;
  } else if (parts.length === 3) {
    // HH:MM:SS
    const [hours, minutes, seconds] = parts;
    return hours * 3600 + minutes * 60 + seconds;
  }

  return 0; // fallback for invalid formats
};
export const secondsToHHMM = (seconds) => {
  if (seconds == 0 || !seconds) return "00:00";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
};

export const getCurrentFY = () => {
  /// "YYYY_YY"
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // getMonth() is 0-based

  const fyStartYear = month >= 4 ? year : year - 1;
  const fyEndYear = fyStartYear + 1;

  const formattedFY = `${fyStartYear}_${String(fyEndYear).slice(-2)}`;
  return formattedFY;
};
export const getCurrentFYByDate = (date) => {
  /// "YYYY_YY"
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const today = new Date(date);
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // getMonth() is 0-based

  const fyStartYear = month >= 4 ? year : year - 1;
  const fyEndYear = fyStartYear + 1;

  const formattedFY = `${fyStartYear}_${String(fyEndYear).slice(-2)}`;
  const obj = { FY: formattedFY, month: months[Number(month) - 1] };
  return obj;
};
// ///////////////////////////////////////////////////////////////////////
export const getMeTheChartType = (crData, data) => {
  let chartType = "bar";
  if (data.dimensions.length > 4) {
    let years = [
      ...new Set(data.dimensions.map((a) => a.slice(9, a.length))),
    ].filter((a) => a != "");
    chartType = crData.includes(years[0]) ? "line" : "bar";
  }
  return chartType;
};

// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ex sample data
// F_YEAR
//  └── ASSET_GROUP
//       └── MAIN_CAUSE
//            └── SUB_CAUSE
//                 └── A_MONTH
//                      └── data (array of final records)
export const flattenData = (array) => {
  const result = [];

  function dfs(node, acc) {
    // Add this node's properties (except children & data)
    const { children, data, ...rest } = node;
    const current = { ...acc, ...rest };

    // If final data exists → push rows
    if (Array.isArray(data)) {
      data.forEach((row) => {
        result.push({ ...current, ...row });
      });
    }

    // Recurse into children
    if (Array.isArray(children)) {
      children.forEach((child) => dfs(child, current));
    }
  }

  array.forEach((root) => dfs(root, {}));
  return result;
};
// ///////////////////////////////////////////////
// groupKey =array
export function sumArrayOfObjects(
  arr,
  groupKeys = [],
  ignoreKeys = [],
  combinedKeyName = "group_id",
) {
  const groups = {};

  arr.forEach((obj) => {
    // Build combined group key string: "2024|JAN"
    const groupId = groupKeys.map((k) => obj[k]).join("|");

    if (!groups[groupId]) {
      groups[groupId] = {};

      // Add group keys to result
      groupKeys.forEach((k) => {
        groups[groupId][k] = obj[k];
      });

      // Add combined key (custom name)
      groups[groupId][combinedKeyName] = groupId;
    }

    // Sum numeric fields (excluding ignore keys and group keys)
    Object.entries(obj).forEach(([key, value]) => {
      if (groupKeys.includes(key)) return;
      if (ignoreKeys.includes(key)) return;
      if (typeof value === "number") {
        groups[groupId][key] = (groups[groupId][key] || 0) + value;
      }
    });
  });

  // Convert object → array of objects
  return Object.values(groups);
}
// //////////////////////////////////////////////////////////////
export const getLastFYyears = () => {
  const today = new Date();
  let year = today.getFullYear();
  const month = today.getMonth() + 1; // Jan = 1

  // Financial year starts in April
  if (month < 4) {
    year -= 1;
  }

  const formatFY = (start) => `${start}-${String(start + 1).slice(2)}`;

  const fyList = [];

  // Current FY + previous 3
  for (let i = 0; i < 4; i++) {
    fyList.push(formatFY(year - i));
  }

  return fyList;
};
///////////////////////////////////////////////////////////////////////////////////////
export function flattenDeep(data) {
  const result = [];

  function helper(node, parentObj = {}) {
    if (Array.isArray(node)) {
      node.forEach((item) => helper(item, parentObj));
      return;
    }

    let hasArray = false;
    const current = { ...parentObj };

    for (const key in node) {
      const value = node[key];

      if (Array.isArray(value)) {
        hasArray = true;
        value.forEach((v) => helper(v, current)); // pass current context
      } else if (typeof value === "object" && value !== null) {
        hasArray = true;
        helper(value, current);
      } else {
        current[key] = value; // copy primitive to context
      }
    }

    // If no nested arrays/objects, it's a final record
    if (!hasArray) {
      result.push(current);
    }
  }

  helper(data);
  return result;
}
export const diffInDays = function (d1, d2) {
  return Math.round(
    Math.abs(new Date(d2) - new Date(d1)) / (1000 * 60 * 60 * 24),
  );
};
export const getDateDifference = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Remove time portion
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);

  return Math.round((d1 - d2) / (1000 * 60 * 60 * 24));
};

export const changeDateByDays = (date, days) => {
  if (!date) return null;

  const d = new Date(date);
  d.setDate(d.getDate() + days);

  return d.toISOString().split("T")[0]; // YYYY-MM-DD
};
// ////////for fy day diff
export const getDayDiffForCurrentFY = (startStr, endStr) => {
  const parse = (d) => {
    const [year, month, day] = d.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  const format = (date) => {
    const d = String(date.getDate()).padStart(2, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${y}-${m}-${d}`; // keep same format
  };

  let start = parse(startStr);
  let end = parse(endStr);

  let calcStart = new Date(start);

  // Your rule: same year but different month
  if (
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() !== end.getMonth()
  ) {
    calcStart = new Date(end.getFullYear(), end.getMonth(), 1);
  }

  const diffTime = end - calcStart;
  const days = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
  return days;
};

// ////////////////////////////////
/**
 * Build ECharts Treemap data from flat array
 *
 * @param {Array} data - array of objects
 * @param {Array} levels - ordered keys for hierarchy
 * @param {String} valueKey - key used as treemap value
 * @param {string } nameKey name of the value Key
 */
export function buildTreemapData(data, levels, valueKey, nameKey) {
  const root = {};

  // Build nested structure with SUM
  data.forEach((item) => {
    let current = root;

    levels.forEach((level, index) => {
      const key = item[level] ?? "Unknown";

      if (!current[key]) {
        // last level stores an object with sum
        current[key] = index === levels.length - 1 ? { __sum: 0 } : {};
      }

      current = current[key];
    });

    // sum the valueKey
    current.__sum += Number(item[valueKey]) || 0;
  });

  // Convert object → ECharts Treemap format
  const toECharts = (node) =>
    Object.entries(node)
      .filter(([key]) => key !== "__sum")
      .map(([name, child]) => {
        if (child.__sum !== undefined) {
          return {
            name,
            value: child.__sum,
          };
        }

        const children = toECharts(child);
        return {
          name,
          value: children.reduce((s, c) => s + c.value, 0),
          children,
        };
      });

  return toECharts(root);
}

// ////////////////////////////////////////////// for Sun Burst //////////////////////////////////////////////////////////////////////
// Pleasant categorical palette (can be extended safely)
const BASE_PALETTE = [
  "#e74c3c", // red
  "#3498db", // blue
  "#2ecc71", // green
  "#9b59b6", // purple
  "#f1c40f", // yellow
  "#e67e22", // orange
  "#1abc9c", // teal
  "#34495e", // navy
];

const ALPHA_BY_LEVEL = ["", "B3", "99", "66", "4D"];
const withAlpha = (hex, alpha = "") => hex + alpha;

/**
 * Build ECharts Sunburst data with dynamic layers
 *
 * @param {Array<Object>} data
 * @param {Object} config
 * @param {string[]} config.layers - hierarchy keys (ANY length)
 * @param {string} config.leafNameKey
 * @param {string} config.leafValueKey
 * @param {string} config.leafTextKey
 */
export function buildSunburstData(
  data,
  { layers, leafNameKey, leafValueKey, leafTextKey },
) {
  const rootMap = {};
  let colorIndex = 0;

  data.forEach((row) => {
    let current = rootMap;
    let parentNode = null;
    const leafValue = row[leafValueKey] ?? 1;

    layers.forEach((layerKey, depth) => {
      const value = row[layerKey];
      if (!value) return;

      if (!current[value]) {
        const baseColor =
          depth === 0
            ? BASE_PALETTE[colorIndex++ % BASE_PALETTE.length]
            : parentNode.baseColor;

        current[value] = {
          name: value, // temp name
          rawName: value, // store original name
          value: 0, // 👈 IMPORTANT
          baseColor,
          itemStyle: {
            color: withAlpha(baseColor, ALPHA_BY_LEVEL[depth] || "33"),
          },
          children: {},
        };
      }

      // 🔼 accumulate value at each level
      current[value].value += leafValue;

      parentNode = current[value];
      current = current[value].children;
    });

    // ✅ Leaf always comes AFTER last layer
    if (parentNode) {
      const leafKey = row[leafNameKey];
      if (!leafKey) return;

      if (!parentNode.children[leafKey]) {
        parentNode.children[leafKey] = {
          name: leafKey,
          value: row[leafValueKey] ?? 1,
          text: row[leafTextKey],
          itemStyle: {
            color: withAlpha(parentNode.baseColor, "66"),
          },
        };
      } else {
        parentNode.children[leafKey].value += row[leafValueKey] ?? 1;
      }
    }
  });

  // Convert nested maps → arrays
  const finalize = (nodeMap) =>
    Object.values(nodeMap).map((node) => {
      if (node.children) {
        node.children = finalize(node.children);
      }
      node.name = `${node.name}\n${node.value}`;
      return node;
    });

  return finalize(rootMap);
}

export function getSunburstTotal(data) {
  return data.reduce((sum, node) => sum + sumNode(node), 0);
}

function sumNode(node) {
  if (!node.children || node.children.length === 0) {
    return node.value ?? 0;
  }

  return node.children.reduce((acc, child) => acc + sumNode(child), 0);
}
// //////////////////////////////////////////////////////////////////////
export const formatDiffDates = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  const diffTime = Math.abs(d2 - d1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

////////////////////////////////////////////////////////////////////////////
const isEmpty = (v) => v === "" || v === null || v === undefined;

export function separateInsertAndUpdate(oldArray, newArray, EXCLUDED_NEW_KEYS) {
  const insert = [];
  const update = [];

  newArray.forEach((newItem, index) => {
    const oldItem = oldArray[index];

    // No matching old record -> Insert
    if (newItem) {
    }
    if (!oldItem || !newItem.id) {
      insert.push(newItem);
      return;
    }

    const updates = {};

    Object.keys(newItem).forEach((field) => {
      if (EXCLUDED_NEW_KEYS.includes(field)) return;

      const oldValue = oldItem[field];
      const newValue = newItem[field];

      // Detect any change
      if (oldValue !== newValue) {
        updates[field] = newValue;
      }
    });

    // Only push if something changed
    if (Object.keys(updates).length > 0) {
      update.push({
        id: newItem.id,
        ind_id: newItem.indent_hdr_id,
        updates,
      });
    }
  });

  return { insert, update };
}
///////////////////////////////////////////////////////////////////////////////////////////////////
// removeKeys
// ///////////////////////////////////////////////////////////////////////////////////////////
export const removeKeys = (arr, keysToRemove) =>
  arr.map((obj) => {
    const newObj = { ...obj };

    keysToRemove.forEach((key) => delete newObj[key]);

    return newObj;
  });

////////////////////////////////////////////////////////////////////////////////////////
export function getTimeDifference(date1, time1, date2, time2) {
  // Create Date objects
  const datetime1 = new Date(`${date1}T${time1}`);
  const datetime2 = new Date(`${date2}T${time2}`);

  // Difference in milliseconds
  const diffMs = Math.abs(datetime2 - datetime1);

  // Convert to days, hours, minutes, seconds
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);
  return {
    totalMilliseconds: Number((diffMs / 1000).toFixed(0)),
    days,
    hours,
    minutes,
    seconds,
  };
}

// ///////////////////////////////////////////////////////////

// const result = universalSeparateInsertAndUpdate(
//   oldArray,
//   newArray,
//   {
//     idKey: "id",

//     excludedKeys: EXCLUDED_NEW_KEYS,

//     updateExtraFields: {
//       ind_id: newItem.indent_hdr_id
//     }
//   }
// );
export function universalSeparateInsertAndUpdate(
  oldArray = [],
  newArray = [],
  options = {},
) {
  const {
    idKey = "id",
    excludedKeys = [],
    getUpdateMeta = () => ({}),
    deepCompare = false,
    normalizeValue = (value) => value,
  } = options;

  const insert = [];
  const update = [];

  // Create old-data lookup
  const oldMap = new Map(
    oldArray
      .filter((item) => item?.[idKey] != null)
      .map((item) => [item[idKey], item]),
  );

  newArray.forEach((newItem) => {
    if (!newItem) return;

    // ==========================================
    // IGNORE COMPLETELY EMPTY ROW
    // Excluded fields are ignored here
    // ==========================================
    if (isEmptyRow(newItem, excludedKeys)) {
      return;
    }

    const newId = newItem[idKey];

    // ==========================================
    // INSERT
    // ==========================================
    if (newId == null || newId === "") {
      insert.push(newItem);
      return;
    }

    const oldItem = oldMap.get(newId);

    // ==========================================
    // ID doesn't exist in old data
    // ==========================================
    if (!oldItem) {
      insert.push(newItem);
      return;
    }

    // ==========================================
    // UPDATE
    // ==========================================
    const updates = {};

    Object.keys(newItem).forEach((field) => {
      // Don't compare excluded fields
      if (excludedKeys.includes(field)) return;

      const oldValue = normalizeValue(oldItem[field]);
      const newValue = normalizeValue(newItem[field]);

      const changed = deepCompare
        ? !isEqual(oldValue, newValue)
        : oldValue !== newValue;

      if (changed) {
        updates[field] = newItem[field];
      }
    });

    // Only add actual changes
    if (Object.keys(updates).length > 0) {
      update.push({
        [idKey]: newId,
        ...getUpdateMeta(newItem, oldItem),
        updates,
      });
    }
  });

  return {
    insert,
    update,
  };
}

// ==========================================
// Check whether row is completely empty
// EXCLUDED KEYS ARE IGNORED
// ==========================================
function isEmptyRow(item, excludedKeys = []) {
  return Object.keys(item)
    .filter((key) => !excludedKeys.includes(key))
    .every((key) => {
      const value = item[key];

      return value === "" || value === null || value === undefined;
    });
}

// ==========================================
// Deep comparison
// ==========================================
function isEqual(a, b) {
  if (a === b) return true;

  if (
    a === null ||
    b === null ||
    typeof a !== "object" ||
    typeof b !== "object"
  ) {
    return false;
  }

  if (Array.isArray(a) !== Array.isArray(b)) {
    return false;
  }

  if (Array.isArray(a)) {
    if (a.length !== b.length) return false;

    return a.every((item, index) => isEqual(item, b[index]));
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  return keysA.every(
    (key) =>
      Object.prototype.hasOwnProperty.call(b, key) && isEqual(a[key], b[key]),
  );
}
// ////////////////////////////////////////////////////////////////////
export const sanitizeMessageHtml = (html = "") => {
  if (typeof window === "undefined") return "";

  const doc = new DOMParser().parseFromString(html, "text/html");

  doc
    .querySelectorAll("script, iframe, object, embed, form, link, meta")
    .forEach((element) => element.remove());

  doc.body.querySelectorAll("*").forEach((element) => {
    [...element.attributes].forEach((attribute) => {
      const name = attribute.name.toLowerCase();
      const value = attribute.value.trim().toLowerCase();

      if (
        name.startsWith("on") ||
        ((name === "href" || name === "src" || name === "xlink:href") &&
          (value.startsWith("javascript:") || value.startsWith("data:")))
      ) {
        element.removeAttribute(attribute.name);
      }
    });
  });

  return doc.body.innerHTML;
};
// /////////////////////////////////////////////////////////////////////
export const htmlToWhatsAppText = (html = "") => {
  if (!html) return "";

  const doc = new DOMParser().parseFromString(html, "text/html");

  // Remove elements that should not become message text.
  doc
    .querySelectorAll(
      "script, style, iframe, object, embed, noscript, template",
    )
    .forEach((el) => el.remove());

  // Preserve clickable links as: Link text (URL)
  doc.querySelectorAll("a").forEach((el) => {
    const href = el.getAttribute("href") || "";
    const text = el.textContent.trim();

    if (/^https?:\/\//i.test(href) && text && href !== text) {
      el.replaceWith(`${text} (${href})`);
    } else if (href && !text) {
      el.replaceWith(href);
    } else {
      el.replaceWith(text || href);
    }
  });

  // Convert HTML formatting to WhatsApp text formatting.
  doc.querySelectorAll("strong, b").forEach((el) => {
    el.replaceWith(`*${el.textContent}*`);
  });

  doc.querySelectorAll("em, i").forEach((el) => {
    el.replaceWith(`_${el.textContent}_`);
  });

  doc.querySelectorAll("s, del, strike").forEach((el) => {
    el.replaceWith(`~${el.textContent}~`);
  });

  doc.querySelectorAll("code").forEach((el) => {
    el.replaceWith(`\`${el.textContent}\``);
  });

  doc.querySelectorAll("pre").forEach((el) => {
    el.replaceWith(`\`\`\`\n${el.textContent.trim()}\n\`\`\``);
  });

  // Preserve line breaks.
  doc.querySelectorAll("br").forEach((el) => {
    el.replaceWith("\n");
  });

  doc.querySelectorAll("li").forEach((el) => {
    el.prepend("• ");
    el.append("\n");
  });

  doc
    .querySelectorAll("p, div, h1, h2, h3, h4, h5, h6, blockquote, tr")
    .forEach((el) => {
      el.append("\n");
    });

  doc.querySelectorAll("td, th").forEach((el) => {
    el.append(" | ");
  });

  // Convert the remaining HTML into plain text.
  return doc.body.textContent
    .replace(/\u00a0/g, " ")
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n[ \t]+/g, "\n")
    .replace(/[ \t]{2,}/g, " ")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};
